import PrintableRewardLinkRedemptionPage from '../../components/printable/PrintableRewardLinkRedemptionPage'
import WhiteLabelPrintableRewardLinkRedemptionPage from '../../components/printable/WhiteLabelPrintableRewardLinkRedemptionPage'
import EmailView from '../../components/email/EmailView'

export const printableRewardLinkRoutes = [
  {
    name: 'Redeem',
    path: '/redeem',
    component: PrintableRewardLinkRedemptionPage,
    meta: {
      segmentName: 'Printed Reward Link Redemption Page'
    }
  },
  {
    name: 'Email',
    path: '/email',
    component: EmailView,
    meta: {
      segmentName: 'Test Email View'
    }
  },
  {
    name: 'White Label Redeem',
    path: '/:uri',
    component: WhiteLabelPrintableRewardLinkRedemptionPage,
    props: true,
    meta: {
      segmentName: 'Customized White-Label Printed Reward Link Redemption Page'
    }
  }
]
